interface RegionPreview {
  funnelBase: string
  funnelPath: string
  widgetBase: string
}

interface Config {
  mode: string
  restApiUrl: string
  regionalRestApiUrl?: Record<string, string>
  affiliateUrl: string
  contactUrl: string
  previewUrl: string
  regionalPreview?: Record<string, RegionPreview>
  firestoreBucketUrl: string
  imageServer: string
  externalScriptFallbackURL: string
  levelUpEnabledLocations: string[]
}

const STAGING_REGIONAL_REST_API: Record<string, string> = {
  au: 'https://staging-au.backend.leadconnectorhq.com',
}

const PRODUCTION_REGIONAL_REST_API: Record<string, string> = {
  au: 'https://au.backend.leadconnectorhq.com',
}
const imageServerWhitelist = [
  'images.unsplash.com',
  'cdn.pixabay.com',
  'storage.googleapis.com',
  'firebasestorage.googleapis.com',
  'pixabay.com',
  'assets-staging.cdn.msgsndr.com',
  'staging.cdn.msgsndr.com',
  'staging.filesafe.space',
  'default.staging.filesafe.space',
  'assets.cdn.msgsndr.com',
  'cdn.msgsndr.com',
  'cdn.filesafe.space',
  'assets.cdn.filesafe.space',
  'img.youtube.com',
  'i.vimeocdn.com',
  'embed-ssl.wistia.com',
  'widgets.leadconnectorhq.com',
  'files.leadconnectorhq.com',
  'staging.files.leadconnectorhq.com',
]

const STAGING_REGIONAL_PREVIEW: Record<string, RegionPreview> = {
  au: {
    funnelBase: 'https://staging.sites-au.leadconnectorhq.com',
    funnelPath: '/preview',
    widgetBase: 'https://funnel-preview-dot-hl-app-stg-au.ts.r.appspot.com',
  },
}

const PRODUCTION_REGIONAL_PREVIEW: Record<string, RegionPreview> = {
  au: {
    funnelBase: 'https://sites-au.leadconnectorhq.com',
    funnelPath: '/preview',
    widgetBase: 'https://funnel-preview-dot-hl-app-prd-au.ts.r.appspot.com',
  },
}

const config: { [key: string]: Config } = {
  development: {
    mode: 'dev',
    restApiUrl: 'https://staging.backend.leadconnectorhq.com',
    affiliateUrl: 'https://staging.backend.leadconnectorhq.com',
    contactUrl: 'https://staging.backend.leadconnectorhq.com/contacts',
    previewUrl: 'https://staging.gohighlevel.com',
    regionalPreview: STAGING_REGIONAL_PREVIEW,
    regionalRestApiUrl: STAGING_REGIONAL_REST_API,
    firestoreBucketUrl: 'https://storage.googleapis.com',
    imageServer: 'https://staging.images.leadconnectorhq.com',
    externalScriptFallbackURL:
      'https://storage.googleapis.com/builder-preview/form_embed/staging/am.js',
    levelUpEnabledLocations: ['iVrVJ2uoXNF0wzcBzgl5'],
  },
  staging: {
    mode: 'staging',
    restApiUrl: 'https://staging.backend.leadconnectorhq.com',
    affiliateUrl: 'https://staging.backend.leadconnectorhq.com',
    contactUrl: 'https://staging.backend.leadconnectorhq.com/contacts',
    previewUrl:
      'https://affiliate-builder-dot-funnel-preview-dot-highlevel-staging.uc.r.appspot.com',
    regionalPreview: STAGING_REGIONAL_PREVIEW,
    regionalRestApiUrl: STAGING_REGIONAL_REST_API,
    firestoreBucketUrl: 'https://storage.googleapis.com',
    imageServer: 'https://staging.images.leadconnectorhq.com',
    externalScriptFallbackURL:
      'https://storage.googleapis.com/builder-preview/form_embed/staging/am.js',
    levelUpEnabledLocations: ['iVrVJ2uoXNF0wzcBzgl5'],
  },
  interop: {
    mode: 'interop',
    restApiUrl: 'https://interop.backend.leadconnectorhq.com',
    affiliateUrl: 'https://interop.backend.leadconnectorhq.com',
    contactUrl: 'https://interop.backend.leadconnectorhq.com/contacts',
    previewUrl: 'https://funnel-preview-dot-highlevel-staging.uc.r.appspot.com',
    firestoreBucketUrl: 'https://storage.googleapis.com',
    imageServer: 'https://staging.images.leadconnectorhq.com',
    externalScriptFallbackURL:
      'https://storage.googleapis.com/builder-preview/form_embed/staging/am.js',
    levelUpEnabledLocations: ['iVrVJ2uoXNF0wzcBzgl5'],
  },
  production: {
    mode: 'production',
    restApiUrl: 'https://backend.leadconnectorhq.com',
    affiliateUrl: 'https://backend.leadconnectorhq.com',
    contactUrl: 'https://backend.leadconnectorhq.com/contacts',
    previewUrl: 'https://app.leadconnectorhq.com',
    regionalPreview: PRODUCTION_REGIONAL_PREVIEW,
    regionalRestApiUrl: PRODUCTION_REGIONAL_REST_API,
    firestoreBucketUrl: 'https://storage.googleapis.com',
    imageServer: 'https://images.leadconnectorhq.com',
    externalScriptFallbackURL:
      'https://stcdn.leadconnectorhq.com/form_embed/prod/am.js',
    levelUpEnabledLocations: [
      'dyKbBe6XZJBFUoxeQyQT',
      'PckM5393o8V8VUL7PYcb',
      'hk9aJw1NxnORXlvWt0Ch',
    ],
  },
}

const override = false

const overrideConfig = {}
const envConfig = config[process.env.NODE_ENV || 'production']

export default override
  ? { ...envConfig, ...overrideConfig, imageServerWhitelist }
  : { ...envConfig, imageServerWhitelist }
